import React, { Component } from "react";
import Link from "./Link";

import "./About.scss";

class About extends Component {
  render() {
    return (
      <div className="container">
        <p>This is the about page.</p>
        <p>Content for the about page lives here.</p>
        <Link page="http://www.facebook.com">Facebook</Link>
      </div>
    );
  }
}

export default About;
